// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1Mior","footer":"ModalFilter_footer__1koNE"};